import { type HUImage } from "@modules/types/imageTypes"
import { z } from "zod"

export const HUImageDtoSchema = z
  .object({
    url: z.string(),
    hash: z.string(),
    key: z.string().nullish(),
  })
  .meta({ id: "HUImageDtoSchema" })

export type HUImageDto = z.infer<typeof HUImageDtoSchema>

// HUImageDraftDto is AssetDto for backend
export const HUImageDraftDtoSchema = z
  .object({
    content: z.string(),
    contentType: z.string(),
  })
  .meta({ id: "HUImageDraftDtoSchema" })
export type HUImageDraftDto = z.infer<typeof HUImageDraftDtoSchema>

export type HUImageDraft = {
  serverPath?: string
  serverBlurHash?: string
  localPath?: string
  localBase64?: string
}

export function convertImageFromDto(dto: HUImageDto): HUImage {
  return {
    url: dto.url,
    key: dto.key ?? "",
    hash: dto.hash,
  }
}

export function convertImageToDto(image: HUImage): HUImageDto {
  return {
    url: image.url,
    key: image.key,
    hash: image.hash,
  }
}
